/* Sticky add-to-cart bar (snippets/sticky-add-to-cart.liquid, 2026-10-24).
   Visible while the form's own Add to cart button has scrolled up out of view and no drawer is open. On phones, once the
   visitor has picked a size, colour or style on the gallery's Dimensions slide (snippets/size-guide, above the form
   there), it also shows while the button is still below the viewport, so the choice can go to the cart from there; it
   hides again while the button itself is on screen. Not on desktop, where the form sits beside the gallery and the
   bar would cover the slide's rows. The variant line,
   price and button state follow the form: the product section's variantChange (theme.js) carries the variant, the
   price is copied from the form's [data-product-price] once the theme has written it, and the button text and
   disabled state come from the form's [data-add-to-cart] button, which the bar also watches, since the name picker
   (assets/asma-name-picker.js) rewrites its label and blocks it with aria-disabled outside variantChange. The bar's
   button clicks that button, so the form's own validation and add-to-cart flow run; while the button is disabled or
   blocked it scrolls to the form (to the name picker when there is one) instead. */
(function () {
  function init(bar) {
    var form = document.getElementById(bar.getAttribute('data-form-id'));
    var section = document.getElementById(bar.getAttribute('data-section-el'));
    if (!form || !section) return;
    var mainButton = form.querySelector('[data-add-to-cart]');
    if (!mainButton) return;
    var button = bar.querySelector('[data-sticky-atc-button]');
    var buttonText = bar.querySelector('[data-sticky-atc-text]');
    var price = bar.querySelector('[data-sticky-atc-price]');
    var variantLine = bar.querySelector('[data-sticky-atc-variant]');
    var root = document.documentElement;
    var sizeIndex = parseInt(bar.getAttribute('data-size-index'), 10);
    // same colours as the form's button (its colour comes from .add-to-cart rules in the theme CSS, not from .btn)
    var mainStyle = getComputedStyle(mainButton);
    button.style.backgroundColor = mainStyle.backgroundColor;
    button.style.borderColor = mainStyle.borderColor;
    button.style.color = mainStyle.color;
    var past = false;
    // a choice made on the Dimensions slide: from then on the bar covers the button being below the viewport too
    var engaged = false;

    function render() {
      var on = past && !root.classList.contains('js-drawer-open');
      if (on === bar.classList.contains('is-visible')) return;
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
      root.style.setProperty('--iwa-sticky-atc-h', bar.offsetHeight + 'px');
      root.classList.toggle('iwa-sticky-atc-on', on);
      // back-to-top.liquid places its button from .sticky-add-to-cart.is-visible on scroll: let it re-measure now
      window.dispatchEvent(new Event('scroll'));
    }

    // the name picker keeps the form's button enabled and marks it blocked until the names are chosen
    function isBlocked() {
      return mainButton.getAttribute('aria-disabled') === 'true' || mainButton.classList.contains('iwa-np-blocked');
    }

    function sync() {
      var formPrice = section.querySelector('[data-product-price]');
      if (formPrice && price) price.textContent = formPrice.textContent.trim();
      var formText = mainButton.querySelector('[data-add-to-cart-text]');
      if (formText && buttonText) buttonText.textContent = formText.textContent.trim();
      button.disabled = mainButton.disabled;
      var blocked = isBlocked();
      button.classList.toggle('is-blocked', blocked);
      if (blocked) button.setAttribute('aria-disabled', 'true'); else button.removeAttribute('aria-disabled');
    }

    function scrollToForm() {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var target = (isBlocked() && section.querySelector('.iwa-np')) || form;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    }

    // A scroll check, not an IntersectionObserver: a fast fling or a jump past the button never makes it
    // "intersect", so an observer would not fire.
    var queued = false;
    function check() {
      queued = false;
      var rect = mainButton.getBoundingClientRect();
      past = rect.bottom < 0 || (engaged && rect.top > window.innerHeight);
      render();
    }
    function onScroll() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(check);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    check();
    new MutationObserver(render).observe(root, { attributes: true, attributeFilter: ['class'] });

    section.addEventListener('variantChange', function (evt) {
      var v = evt.detail && evt.detail.variant;
      if (variantLine && v && v.options) {
        var parts = v.options.filter(function (o, i) { return i !== sizeIndex; });
        if (sizeIndex >= 0 && v.options[sizeIndex]) parts.push(v.options[sizeIndex]);
        variantLine.textContent = parts.join(' · ');
      }
      setTimeout(sync, 0);
    });
    new MutationObserver(sync).observe(mainButton, {
      attributes: true, attributeFilter: ['class', 'disabled', 'aria-disabled'],
      childList: true, characterData: true, subtree: true
    });
    sync();

    button.addEventListener('click', function () {
      if (mainButton.disabled || isBlocked()) { scrollToForm(); return; }
      // In the next task: the cart drawer this add opens listens for outside clicks on window, and this click has
      // not reached window yet, so clicking the form's button now would close the drawer as it opens.
      setTimeout(function () { mainButton.click(); }, 0);
    });
    // a chip on this product's Dimensions slide (keyboard picks click the chip too, size-guide.js)
    document.addEventListener('click', function (evt) {
      var t = evt.target;
      if (engaged || !t || !t.closest || !t.closest('[data-size-guide-slide] [role="radio"]')) return;
      if (!section.contains(t) || !window.matchMedia('(max-width: 768px)').matches) return;
      engaged = true;
      onScroll();
    });
    bar.querySelector('[data-sticky-atc-scroll]').addEventListener('click', scrollToForm);
  }

  function start() { document.querySelectorAll('[data-sticky-atc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
